import logoUrl from '../../assets/logo.svg';

interface Props {
  health: unknown;
}

export function Topbar({ health: _health }: Props) {
  return (
    <header className="topbar">
      <a className="brand-logo" href="/" aria-label="SKAIRA">
        <img src={logoUrl} alt="SKAIRA" />
      </a>
    </header>
  );
}
